import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/encounter-type";

export const getAllEncounterType = () => axios.get(API_PATH + "/get-all");

export const pagingEncounterType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getEncounterTypeById = (encounterTypeId) => axios.get(API_PATH + "/getbyid/" + encounterTypeId);

export const saveOrUpdateEncounterType = encounterType => axios.post(API_PATH + "/save", encounterType);

export const deleteEncounterType = encounterTypeId => axios.delete(API_PATH + '/mark-delete/' + encounterTypeId);
